var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bizcomp-private-hot bizcomp ' + _vm.className},[_c('comp-title',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"title":_vm.title}}),(_vm.fund.length>2)?_c('hot-tab',{attrs:{"private-val":true,"fund-info":_vm.fund},on:{"fund-continue":_vm.fundBuy}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }